export const ORDER_STATUS_LABELS_UZ = {
    CREATED: 'Yaratildi',
    DIAGNOSTIC: 'Diagnostika',
    REPAIRING: 'Ta\'mirda',
    WAITING_PARTS: 'Ehtiyot qism kutmoqda',
    READY: 'Tayyor',
    DELIVERED: 'Topshirildi',
    CANCELLED: 'Bekor qilindi',
};
export const ORDER_STATUS_LABELS_RU = {
    CREATED: 'Создан',
    DIAGNOSTIC: 'Диагностика',
    REPAIRING: 'В ремонте',
    WAITING_PARTS: 'Ожидание запчастей',
    READY: 'Готов',
    DELIVERED: 'Выдан',
    CANCELLED: 'Отменён',
};
export const ORDER_STATUS_FLOW = {
    CREATED: ['DIAGNOSTIC', 'CANCELLED'],
    DIAGNOSTIC: ['REPAIRING', 'WAITING_PARTS', 'CANCELLED'],
    REPAIRING: ['WAITING_PARTS', 'READY', 'CANCELLED'],
    WAITING_PARTS: ['REPAIRING', 'READY', 'CANCELLED'],
    READY: ['DELIVERED'],
    DELIVERED: [],
    CANCELLED: [],
};
export const KANBAN_STATUSES = [
    'CREATED',
    'DIAGNOSTIC',
    'REPAIRING',
    'WAITING_PARTS',
    'READY',
    'DELIVERED',
];
export const SERVICE_CATEGORY_LABELS_UZ = {
    DIAGNOSTICS: 'Diagnostika',
    REPAIR: 'Ta\'mir',
    MAINTENANCE: 'Texnik xizmat',
    BODY: 'Kuzov',
    ELECTRIC: 'Elektr',
    TIRE: 'Shina',
    OTHER: 'Boshqa',
};
export const PAYMENT_METHOD_LABELS_UZ = {
    CASH: 'Naqd',
    CARD: 'Karta',
    CLICK: 'Click',
    PAYME: 'Payme',
    DEBT: 'Qarz',
};
export const ROLE_LABELS_UZ = {
    WORKSHOP_OWNER: 'Servis egasi',
    WORKSHOP_STAFF: 'Xodim',
    CUSTOMER: 'Mijoz',
    PLATFORM_ADMIN: 'Administrator',
};
export const WORKSHOP_ROLE_LABELS_UZ = {
    OWNER: 'Egasi',
    MANAGER: 'Menejer',
    MECHANIC: 'Mexanik',
    VIEWER: 'Kuzatuvchi',
};
export const DEFAULT_CURRENCY = 'UZS';
export const DEFAULT_LANGUAGE = 'uz';
export const TRIAL_DAYS = 30;
export const RATE_LIMIT_BOT_PER_MIN = 30;
export const RATE_LIMIT_API_PER_MIN = 100;
export const MAX_PHOTOS_PER_LOG = 10;
export const MAX_PHOTOS_PER_ORDER = 10;
export const SUBSCRIPTION_REMINDER_DAYS = [7, 3, 1, 0];
export const WORKER_TICKER_MS = 60_000;
export const PLAN_LABELS_UZ = {
    FREE: 'Bepul',
    STARTER: 'Boshlovchi',
    PRO: 'Pro',
};
export const SUBSCRIPTION_STATUS_LABELS_UZ = {
    TRIAL: 'Sinov muddati',
    ACTIVE: 'Faol',
    EXPIRED: 'Tugagan',
    CANCELLED: 'Bekor qilingan',
};
//# sourceMappingURL=index.js.map